import { LabelHTMLAttributes } from 'react';
import clsx from 'clsx';

export interface FormLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  optional?: boolean;
}

export const FormLabel = ({
  required = false,
  optional = false,
  children,
  className,
  ...props
}: FormLabelProps) => {
  return (
    <label
      className={clsx(
        'block text-sm font-medium text-gray-700 mb-1.5',
        className
      )}
      {...props}
    >
      {children}
      {required && <span className="ml-1 text-red-500">*</span>}
      {optional && <span className="ml-1 text-gray-400 font-normal">(Optional)</span>}
    </label>
  );
};
